/* LIBRAIRIRES */
import * as React from 'react';
import { useNavigate } from "react-router-dom";

/* FIREBASE */
import { auth } from '../../firebase'; //importer votre instance firebase
import { onAuthStateChanged, signOut } from 'firebase/auth';

/* COMPONENTS */
import ModalUser from '../ModalUser/ModalUser';

/* LOADER */
import { Triangle } from 'react-loader-spinner';

/* LOGO */ 
import logoMobile from '../../Assets/Logos/logo-mobile.svg';
import logoDesktop from '../../Assets/Logos/logo.svg';

/* MUI */
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';

/* ICONS */
import login from "../../Assets/Icons/login.svg";
import signIn from "../../Assets/Icons/sign-in.svg";
import loginWhite from "../../Assets/Icons/login-white.svg";
import signInWhite from "../../Assets/Icons/sign-in-white.svg";

/* CSS */
import './Navbar.css';

const pages = ['Accueil', 'Nos Prestations', 'Devis'];
const settings = ['Mon profil', 'Dashboard', 'Déconnexion'];

function ResponsiveAppBar() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [isDashboard, setIsDashboard] = React.useState(false);
    const [openProfil, setOpenProfil] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [loginIcon, setLoginIcon] = React.useState(login);
    const [signInIcon, setSignInIcon] = React.useState(signIn);
    const [logo, setLogo] = React.useState(logoDesktop);
  
    const navigate = useNavigate();

    const styles = theme => ({
        [theme.breakpoints.up('md')]: {
            position: "static",
        }
    });
      
    React.useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 899px)');
        const handleMediaQueryChange = (event) => {
            const newLoginIcon = event.matches ? loginWhite : login
            const newSignInIcon = event.matches ? signInWhite : signIn
            const newLogo = event.matches ? logoMobile : logoDesktop
            setLoginIcon(newLoginIcon);
            setSignInIcon(newSignInIcon);
            setLogo(newLogo);
        };
        mediaQuery.addListener(handleMediaQueryChange);
        handleMediaQueryChange(mediaQuery);
        return () => mediaQuery.removeListener(handleMediaQueryChange);
  }, []);

    React.useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                setIsDashboard(true);
            } else {
                setIsDashboard(false);
            }
        });
    
        // nettoyer l'abonnement lorsqu'on quitte le component
        return unsubscribe;
        
    }, []);

    const userSignOut = () => {
        signOut(auth).then(() => {
        console.log('Sign out successful');
    }).catch((error) => {
        console.log(error);
    })
}

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = (page, e) => {
        console.log(page)
        /* const targetUrl = page?.nativeEvent ? page.nativeEvent.explicitOriginalTarget.textContent : page; */
        if (typeof page == 'string') {
            const url = page.replace(" ", "");
            navigate(`/${url}`)
            setAnchorElNav(null);
        } else {
            return;
        }
        /* const url = typeof page == 'string' && page.replace(" ", "");
        navigate(`/${url}`)
        setAnchorElNav(null); */
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    function handleClick(e) {   
        const elementClicked = e.target.textContent;
        if (elementClicked === 'Déconnexion') {
            setIsLoading(true);
            setTimeout(() => {
                userSignOut();
                handleCloseUserMenu();
                setIsLoading(false);
            }, 3000)
        } else if(elementClicked === 'Dashboard') {
            navigate('/Dashboard');
        } else {
            setOpenProfil(true);
        }
    }

    function handleClickLogo() {
        navigate('/');
    }

    return (
        <AppBar sx={styles} style={{ 
            justifyContent: "center", 
            height: "100px", 
            background: "rgb(40, 34, 82)"
        }} 
        >
        <Container width="100%" style={{backgroundColor: "rgb(40,34,82)"}}>
            <Toolbar disableGutters style={{justifyContent: "space-between", width: "100%", position: "relative"}}>
            <img className='logo' src={logo} alt='Logo' onClick={handleClickLogo} />
            <Typography
                variant="h6"
                noWrap
                component="a"
                href="/"
                sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none', 
                }}
            >
                
            </Typography>

            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
                >
                <MenuIcon />
                </IconButton>
                <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                    display: { xs: 'block', md: 'none' },
                }}
                >
                {pages.map((page) => (
                    <MenuItem key={page} onClick={(e) => handleCloseNavMenu(page, e)}>
                    <Typography textAlign="center">{page}</Typography>
                    </MenuItem>
                ))}
                </Menu>
            </Box>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                {pages.map((page) => (
                <Button
                    key={page}
                    onClick={(e) => handleCloseNavMenu(page, e)}
                    sx={{ my: 2, color: 'white', display: 'block' }}
                >
                    {page}
                </Button>
                ))}
            </Box>
            {
                isDashboard ? 
                <Box sx={{ flexGrow: 0 }}>
                <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                </IconButton>
                </Tooltip>
                <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
                >
                {settings.map((setting) => (
                    <MenuItem key={setting} onClick={handleClick}>
                    <Typography textAlign="center">{setting}</Typography>
                    </MenuItem>
                ))}
                </Menu>
            </Box>
            : 
            <div className='navbar-buttons'>
                <button className='navbar-button' onClick={() => navigate("/Login")}><img src={loginIcon} alt="connexion" /> Se connecter</button>
                <button className='navbar-button' onClick={() => navigate("/Signup")}><img src={signInIcon} alt="inscription" />Inscription</button>
            </div>
            }
            
            </Toolbar>
        </Container> 
        {
            openProfil && <ModalUser openProfil={openProfil} setOpenProfil={setOpenProfil}/>
        }
        { isLoading && 
            <div className='container-loader-logout'>
            <Triangle
                height="150"
                width="150"
                color="#FFD700"
                ariaLabel="triangle-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
            />
            </div>
        }
        </AppBar>
        
    );
}
export default ResponsiveAppBar;